import React, { useState } from 'react';
import {
  Button,
  Box,
  Grid,
  Typography,
  Radio,
  Stack,
  useTheme,
  ButtonGroup,
  Checkbox,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from '@mui/material';
import InputField from 'components/Input-Field/input-field';
import LabelValueBox from 'components/LabelValueBox';
import { tokens } from 'theme/tokens';
import ButtonSave from 'components/ButtonSave';
import StatusPill from 'components/StatusPill';

const AssignDriver = ({
  legDistance,
  isOTR,
  isIndividualDriver,  
  drivers,
  assignedDrivers,
  fnOnAssignDriverHandler,
}) => {

  const RATE_TYPES = {
    'FIXED RATE': 'FIXED',
    'CPM': 'CPM',
    // 'LOAD PERCENT' : 'PERCENTAGE', 
    'PER HOUR': 'HOURLY'
  };
  // const RATE_TYPES = ['CPM', 'FLAT', 'FIXED', 'PERCENTAGE', 'HOURLY'];
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [driverAssignment, setDriverAssignment] = isIndividualDriver ? useState('INDIVIDUAL') : useState('TEAM');  

  {/* We need to support team */}  
  const [selectedDrivers, setSelectedDrivers] = useState(assignedDrivers || []);

  const [driverRate, setDriverRate] = useState(assignedDrivers.length > 0 ? assignedDrivers.map(d => d.rate) : []);
  const [driverRateType, setDriverRateType] = useState(assignedDrivers.length > 0 ? assignedDrivers.map(d => d.rateType) : ['FIXED']);
  const [driverDistance, setDriverDistance] = useState(assignedDrivers.length > 0 ? assignedDrivers.map(d => d.miles) : [legDistance]);
  const [driverHours, setDriverHours] = useState(assignedDrivers.length > 0 ? assignedDrivers.map(d => d.hours) : []);

  const handleDriverSelection = (evt, driver) => {
    if (driverAssignment === 'INDIVIDUAL') {
      const driver = drivers.filter(d => d.id === Number(evt.target.value));
      setSelectedDrivers(driver);
    } else {
      // does this driver exists already ?        
      const isDriverExists = selectedDrivers.some(d => d.id === driver.id);
      if (isDriverExists) { // Existing Driver. Remove the existing driver
        const updatedSelection = selectedDrivers.filter(d => d.id !== driver.id);
        setSelectedDrivers(updatedSelection);
      } else {  // New Driver        
        const updatedSelection = selectedDrivers.concat(driver);
        const updatedRateTypes = driverRateType.concat('FIXED');
        const updatedDistance = driverDistance.concat(legDistance);
        setDriverRateType(updatedRateTypes);
        setDriverDistance(updatedDistance);
        setSelectedDrivers(updatedSelection);
      }
    }
  };

  const handleDriverRateChange = (evt, index) => {
    const rates = [...driverRate];
    rates[index] = Number(evt.target.value);
    setDriverRate(rates);
  };

  const handleDriverHours = (evt, index) => {
    const hours = [...driverHours];
    hours[index] = Number(evt.target.value);
    setDriverHours(hours);
  };

  const handleDriverDistance = (evt, index) => {
    const miles = [...driverDistance];
    miles[index] = Number(evt.target.value);
    setDriverDistance(miles);
  };

  const handleRateTypeChange = (evt, index) => {
    const rateTypes = [...driverRateType];
    rateTypes[index] = evt.target.value;
    setDriverRateType(rateTypes);
  };
  
  const assignSelectedDriver = () => {    
    const assignedDrivers = selectedDrivers.map((selectDriver, idx) => {      
      const rateType = driverRateType[idx];
      return {
        id: selectDriver.id,
        rate: Number.parseFloat(driverRate[idx]),
        rateType: rateType,
        miles: driverDistance[idx],
        hours: driverHours[idx],
      };
    });
    //Assign team vs individual
    isOTR ? fnOnAssignDriverHandler(assignedDrivers) : assignedDrivers.map(d => fnOnAssignDriverHandler(d));
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 7 }}>
        {isOTR ?
          <Box sx={{
            border: `1px solid ${colors.neutral[200]}`,
            borderRadius: '6px',
            p: 1,
            mb: 1,
            display: 'flex',
            justifyContent: 'space-between'
          }}
          >
            <Typography variant='subtitle2' style={{ fontWeight: 500 }}>Driver Assignment</Typography>
            <ButtonGroup size='small' color='secondary'>
              <Button
                disabled={selectedDrivers.length > 1}
                variant={driverAssignment === 'INDIVIDUAL' ? 'contained' : 'outlined'}
                onClick={() => { setDriverAssignment('INDIVIDUAL'); }}
              >
                Individual                
              </Button>
              <Button
                variant={driverAssignment === 'TEAM' ? 'contained' : 'outlined'}
                onClick={() => {setDriverAssignment('TEAM');}}
              >
                Team
              </Button>
            </ButtonGroup>
          </Box> :
          <React.Fragment />
        }
        <Stack spacing={1} sx={{
          border: `1px solid ${colors.neutral[200]}`,
          borderRadius: '6px',
          p: 1,
          height: '70vh',
          overflowY: 'scroll'
        }}
        >
          {drivers.map(driver => (
            <Box key={driver.id} sx={{
              border: `1px solid ${colors.neutral[200]}`,
              borderRadius: '6px',
              p: 1,
            }}
            >
              <Stack direction={'row'} spacing={1} sx={{ display: 'flex', justifyContent: 'space-between' }} pb={1}>
                <Typography variant='body1'>{driver.fullName}</Typography>
                <Typography variant='body1'>{driver.driverType}</Typography>
                <StatusPill status={driver.available ? 'YES' : 'NO'} label={driver.available ? 'Available' : 'Un Available'} size='small' />
              </Stack>
              <Stack direction={'row'} spacing={1}>
                <LabelValueBox label={'Phone'} value={driver.phone} />
                <LabelValueBox label={'License Exp.'} value={driver.licenseExpiryDate} />
                <LabelValueBox label={'Rate'} value={driver.rate} />
                {driverAssignment === 'INDIVIDUAL' ?
                  <Radio
                    checked={selectedDrivers.some(d => d.id === driver.id)}
                    onChange={(evt) => handleDriverSelection(evt)}
                    value={driver.id}
                    name='radio-buttons'
                    size='small'
                  /> :
                  <Checkbox
                    size='small'
                    checked={selectedDrivers.some(d => d.id === driver.id)}
                    disabled={assignedDrivers.some(d => d.id === driver.id)}
                    value={driver.id}
                    onClick={(evt) => handleDriverSelection(evt, driver)}
                  />
                }
              </Stack>
            </Box>
          ))}
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 5 }}>
        <Box>
          {selectedDrivers.length === 0 && 
          <Typography variant='subtitle2' sx={{
              fontWeight: 500, color: colors.neutral[600], textTransform: 'uppercase', letterSpacing: 0.5,
              textAlign: 'center', marginTop: '50%'
              }}
            >
            {'Please select at least one driver'}
          </Typography>}
        </Box>
        {selectedDrivers.map((driver, idx) => (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <Typography variant='subtitle1'>{driver.fullName}{driver.type}</Typography>
              <Typography variant='body1'>{driver.phone}</Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth>
                <InputLabel id='payment-label'>Select Rate Type</InputLabel>              
                <Select
                  labelId='payment-label'
                  name={`${driverRateType[idx]}`}
                  value={driverRateType[idx]}
                  onChange={(e) => handleRateTypeChange(e, idx)}
                  margin='dense'
                  size='small'
                  fullWidth
                >
                  {Object.entries(RATE_TYPES).map(([key, value]) => (
                    <MenuItem key={key} value={value}>{key}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <InputField
                autoFocus
                type='number'
                label='Enter Rate'
                name={`${driverRate[idx]}`}
                onChange={e => handleDriverRateChange(e, idx)}
                value={driverRate[idx]}
                isFullWidth={true}
                valid />
            </Grid>            
            <Grid size={{ xs: 12, sm: 6 }}>
              <InputField
                autoFocus
                type='number'
                label='Enter Total Miles'
                name='totalDistance'
                onChange={e => handleDriverDistance(e, idx)}
                value={driverDistance[idx]}
                isFullWidth={true}
                disabled={driverRateType[idx] !== 'CPM'}
                valid />
            </Grid>
            <Grid size={{xs: 6}}>
              {driverRateType[idx] === 'HOURLY' && <InputField
                autoFocus
                type='number'
                label='Enter Driver Hours'
                name={`${driverHours[idx]}`}
                onChange={e => handleDriverHours(e, idx)}
                value={driverHours[idx]}
                isFullWidth={true}
                valid />
              }
            </Grid>
            <Grid size={{ xs: 12 }}>
              {driverRateType[idx] === 'CPM' && <Typography variant='body1' fontWeight={500} sx={{color: colors.neutral[500]}}>{`Total Pay: ${Number(driverRate[idx] * driverDistance[idx]).toFixed(2)} `}</Typography> }
              {driverRateType[idx] === 'HOURLY' && <Typography variant='body1' fontWeight={500} sx={{color: colors.neutral[500]}}>{`Total Pay: ${Number(driverRate[idx] * driverHours[idx]).toFixed(2)} `}</Typography> }
            </Grid>
          </Grid>
        ))}
        {selectedDrivers && selectedDrivers.length > 0 && <Box display={'flex'} justifyContent={'flex-end'}>
          <br/>          
          <ButtonSave
            title={'Assign Driver'}
            size={'lg'}
            action={assignSelectedDriver}
          />
        </Box>
        }
      </Grid>
    </Grid>
  );
};

export default AssignDriver;
